import React, { Component } from "react";
import "./EndStep.css";
import api from "../../../../api/index";
import FaCreditCardAlt from "react-icons/lib/fa/credit-card-alt";
import FaFilePdfO from "react-icons/lib/fa/file-pdf-o";
import AddresIcon from "../../../../components/Svgs/AddresIcon";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";
import FaFileTextO from "react-icons/lib/fa/file-text-o";
import { FaAutomobile } from "react-icons/lib/fa/index";
import moment from "moment";
import Gel from "../../../../components/Svgs/Gel";
import { Link } from "react-router-dom";
import ReactGA from "react-ga4";

import { setActiveLanguage } from "react-localize-redux";

class EndStep extends Component {
  constructor() {
    super();
    this.state = {
      attachments: [],
      insurerName: "",
      insurerLastname: "",
      insurerIdentificationNumber: "",
      policy: {},
      status: {
        active: "A",
        inactive: "I",
      },
    };
  }

  componentWillMount() {
    window.scrollTo(0, 0);
    if (
      !localStorage.getItem("currentLanguage") ||
      localStorage.getItem("currentLanguage") === null
    ) {
      localStorage.setItem("currentLanguage", "ka");
    }
  }

  componentDidMount() {
    this.props.dispatch(
      setActiveLanguage(localStorage.getItem("currentLanguage"))
    );
    // this.props.onClick(e,"ka")
    if (this.props.policyId && this.props.status === "success") {
      api.policy.getPolicy(this.props.policyId).then((res) => {
        this.setState({
          policy: res.data,
        });
      });

      api.policy.getPolicyDocuments(this.props.policyId).then(({ data }) => {
        this.setState({
          attachments: data,
        });
      });
    }
  }

  onPaying = () => {
    api.policy.getPolicy(this.props.policyId).then(({ data }) => {
      this.setState(
        {
          insurerName: data.insurerName,
          insurerLastname: data.insurerLastname,
          insurerIdentificationNumber: data.insurerIdentificationNumber,
        },
        () => {
          let paymentOb = {
            policyAggregateId: this.props.policyId,
            aggregateId: this.props.aggregateId,
            bankTerminalId: 0,
            bankTransactionId: "string",
            paymentTypeId: 3,
            payer: this.state.insurerName + this.state.insurerLastname,
            payerIdentificationNumber: this.state.insurerIdentificationNumber,
            cashboxId: 0,
          };
        }
      );
    });
  };
  handlePolicyStatus = (status) => {
    if (status === this.state.status.active) {
      return (
        <h4 className="result-item-top-text">
          {this.props.translate("activePolicy")}
        </h4>
      );
    } else if (status === this.state.status.inactive) {
      return (
        <h4 style={{ color: "#cccccc" }} className="result-item-top-text">
          {this.props.translate("notActivePolicy")}
        </h4>
      );
    }
  };
  onBackPolicy = () => {
    this.props.onChange();
  };

  formatDate = (date) => {
    return moment(date).format("LL");
  };

  handleSuccesPageStatus = (policy) => {
    if (policy.policyActiveStatus === this.state.status.active) {
      return policy.period > 1
        ? this.props.translate("left") +
            policy.period +
            " " +
            this.props.translate("day")
        : this.props.translate("left") +
            policy.period +
            " " +
            this.props.translate("year");
    } else if (policy.policyActiveStatus === this.state.status.inactive) {
      return (
        this.props.translate("willBeActive") +
        " " +
        moment(policy.startDate).format("DD MMM YYYY")
      );
    }
  };

  handleInprogressOnErrorSide = (resourceInterval) => {
    let array = window.location.href.split("/");
    array[array.length - 1] = "error";
    let url = array.join("/");
    window.location.href = url;
    clearInterval(resourceInterval);
  };

  handleInprogressOnSuccessSide = (resourceInterval) => {
    let array = window.location.href.split("/");
    array[array.length - 1] = "success";
    let url = array.join("/");
    window.location.href = url;
    clearInterval(resourceInterval);
  };

  handleInprogressStatus = () => {
    let tryCheckCount = 8;

    let resourceInterval;

    resourceInterval = setInterval(() => {
      tryCheckCount--;

      if (tryCheckCount === 0) {
        this.handleInprogressOnErrorSide(resourceInterval);
        return;
      }

      api.policy.getPolicy(this.props.policyId).then(({ data }) => {
        if (data) {
          switch (data.paymentStatus) {
            /** paid */
            case "P":
              {
                this.handleInprogressOnSuccessSide(resourceInterval);
              }
              break;
            /** not paid */
            case "N":
              /** continue polling*/
              break;
            /** declined */
            case "D":
              {
                this.handleInprogressOnErrorSide(resourceInterval);
              }
              break;
          }
        } else {
          this.handleInprogressOnErrorSide(resourceInterval);
        }
      });
    }, 5000);
  };

  render() {
    const { status, translate } = this.props;
    const { policy, attachments } = this.state;
  
    ReactGA.ga("set", "ecommerce");
    ReactGA.event("ecommerce", "addItem", {
      id: "f2a1208c-a556-4da1-ba2b-a73f59ff4161",
      name: policy.vehicleCategory,
      price: policy.premium,
      category: policy.vehicleCategory,
      country: policy.insurerCitizenship,
    });
    ReactGA.event("ecommerce", "transaction", {
      id: policy.uId,
      revenue: policy.premium,
    });
    console.log(this.state, "dibidibidibi daaa");
    console.log(
      "dabadaba daba diii"
    );
    return (
      <div>
        {status === "inprogress" && (
          <div className="end-step-inprogress">
            {/* <div className="end-step-inprogress-icon" /> */}
            <div class="load-wrapp">
              <div class="load-3">
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
              </div>
            </div>
            <h2 className="end-step-inprogress-header">
              {translate("payingInProgress")}!
            </h2>
            <div className="end-step-btn-content">
              {this.handleInprogressStatus()}
              <button className="end-step-btn" onClick={this.onPaying}>
                <FaCreditCardAlt className="end-step-card-icon" />
                {translate("payingAgain")}
              </button>
              <Link to="/">
                <button
                  className="end-step-btn"
                  // onClick={this.onBackPolicy}
                >
                  <div className="end-step-card-icon-back">
                    <AddresIcon />
                  </div>
                  {translate("returnPolicy")}
                </button>
              </Link>
            </div>
          </div>
        )}
        {status === "error" && (
          <div className="end-step-err">
            <div className="end-step-err-icon" />
            <h2 className="end-step-err-header">{translate("payingError")}!</h2>
            <div className="end-step-btn-content">
              <button className="end-step-btn" onClick={this.onPaying}>
                <FaCreditCardAlt className="end-step-card-icon" />
                {translate("payingAgain")}
              </button>
              <Link to="/">
                <button
                  className="end-step-btn"
                  // onClick={this.onBackPolicy}
                >
                  <div className="end-step-card-icon-back">
                    <AddresIcon />
                  </div>
                  {translate("returnPolicy")}
                </button>
              </Link>
            </div>
          </div>
        )}
        {status === "success" && (
          <div className="end-step-card">
            <div className="end-step-info-person">
              <div className="end-step-info-item end-step-info-item-policy">
                <div className="end-step-policy-icon">
                  <FaFileTextO />
                </div>
                <div className="end-step-policy-info">
                  <div>{policy.policyNumber}</div>
                  {/* <div></div> */}
                </div>
              </div>
              <div className="end-step-info-item">
                <div className="end-step-person-name">
                  {
                    policy.insurerTitle
                    // ? policy.insurerTitle + " " + policy.insurerName : `${policy.insurerName}`
                    //  ${policy.insurerLastname}
                  }
                </div>
                <div>{policy.insurerIdentificationNumber}</div>
              </div>
              <div className="end-step-info-item">
                <div className="end-step-info-status">
                  {" "}
                  {this.handlePolicyStatus(policy.policyStatus)}
                </div>
                <span className="end-step-info-duration">
                  {
                    this.handleSuccesPageStatus(policy)
                    // policy.policyActiveStatus === "A" ?
                    // translate('left') policy.period > 1 ? policy.period + " " + translate('day') : policy.period + " " + translate('year')
                    //  : policy.policyActiveStatus === "A" ?
                  }
                </span>
              </div>
            </div>
            <div className="end-step-info-bordered">
              <div className="end-step-info-item end-step-info-vehicle">
                <div className="end-step-vehicle-icon">
                  <FaAutomobile />
                </div>
                <div>
                  <div>{policy.vinCode}</div>
                  <div>{policy.chassisNumber}</div>
                  <div className="end-step-vehicle">
                    {policy.vehicleManufacturer} / {policy.vehicleModel}
                  </div>
                  <div className="end-step-category">
                    {translate("" + policy.vehicleCategoryNumber)}
                  </div>
                </div>
              </div>
              <div className="end-step-info-item">
                <div className="end-step-price">
                  {policy.premium} <Gel width={15} />
                </div>
                <div className="end-step-date-label">
                  {translate("buyDate")}:
                </div>
                <div className="end-step-date">
                  {this.formatDate(policy.issueDate)}
                </div>
              </div>
              <div className="end-step-info-item">
                <div className="end-step-date-label">
                  {translate("activePeriod")}:
                </div>
                <div className="end-step-date">
                  {this.formatDate(policy.startDate)}
                </div>
                <div className="end-step-date">
                  {this.formatDate(policy.endDate)}
                </div>
              </div>
            </div>
            <div className="end-step-description">
              {translate("payingSuccess")}.{translate("sendPolicy")}{" "}
              {translate("onMail")}
              <span className="mailMessageStyle"> {policy.insurerEmail}, </span>
              {translate("onPhone")}{" "}
              <span className="mailMessageStyle"> {policy.insurerPhone}, </span>
              {translate("printDocuments")}
            </div>
            <div className="attachments">
              {attachments.map((attachment) => {
                return (
                  <a
                    href={attachment.url}
                    target="_blank"
                    className="attachment"
                    key={attachment.documentId}
                  >
                    <span className="attachment-icon" />
                    <span className="attachment-text">
                      {translate(attachment.documentTypeId)}
                    </span>
                  </a>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  translate: getTranslate(state.locale),
});
export default connect(mapStateToProps)(EndStep);



// WEBPACK FOOTER //
// ./src/pages/PoliciesCreatePage/steps/EndStep/EndStep.js